module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_20_25.8ed7f50d.png";